import styled from 'styled-components';

export const Content = styled.div`
  /* position: absolute;
  right: 65px;
  top: -3px; */
  margin-right: 5px;
  width: 83px;
  label {
    color: #aab2b8;
    display: block;
    font-size: 11px;
    line-height: 1;
    margin: 0 0 1px;
  }
  select {
    cursor: pointer;
    width: 100%;
    font-size: 11px;
    padding: 3px 22px 3px 6px;
    background-color: #161e23;
    color: #e6eaec;
    border-radius: 8px;
    border: solid 1px #3d4952;
    background-size: 12px;
    background-position: right 6px center;
    option {
      font-size: 11px;
    }
  }
`;
